export enum EQuotaHeaderName {
  NodePoolPriority = "NodePoolPriority",
  NodePool = "NodePool",
  OverQuotaState = "OverQuotaState",
  GpuQuota = "GpuQuota",
  CpuQuota = "CpuQuota",
  CpuMemoryQuota = "CpuMemoryQuota",
  ProjectPriority = "ProjectPriority",
  DepartmentPriority = "DepartmentPriority",
  OverQuotaWeight = "OverQuotaWeight",
  OverQuota = "OverQuota",
  ProjectGpuLimit = "ProjectGpuLimit",
  DepartmentGpuLimit = "DepartmentGpuLimit",
}

export enum EQuotaHeaderLabel {
  NodePoolPriority = "Priority",
  NodePool = "Node pool",
  OverQuotaState = "Over-quota state",
  GpuQuota = "GPU devices",
  CpuQuota = "CPUs (Cores)",
  CpuMemoryQuota = "CPU memory",
  ProjectPriority = "Project priority",
  DepartmentPriority = "Department priority",
  OverQuotaWeight = "Over-quota weight",
  OverQuota = "Over-quota",
  ProjectGpuLimit = "Project max. GPU device allocation",
  DepartmentGpuLimit = "Department max. GPU device allocation",
}

export interface HeaderConfig {
  name: EQuotaHeaderName;
  label: EQuotaHeaderLabel;
  tooltipText?: string;
  aid: string;
}
